import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import member from './modules/member'
import provider from './modules/provider'
import getters from './getters'
import tagsView from './modules/tagsView' //新增
import settings from './modules/settings' //新增
import dicData from './modules/dicData' //数据字典
import dicDataV2 from './modules/dicDataV2' //数据字典V2
import countData from './modules/countData'
import btnLoading from './modules/btnLoading'
import searchDataRemote from './modules/searchDataRemote'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    member,
    provider,
    tagsView,
    settings,
    dicData,
    countData,
    btnLoading,
    dicDataV2,
    searchDataRemote
  },
  getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js